import { createContext, useContext } from 'react';

import { SyncedRequestState } from './types';

const SyncedRequestContext = createContext<Nullable<SyncedRequestState>>(null);

const useSyncedRequestContext = () => {
  const state = useContext(SyncedRequestContext);

  if (!state) {
    throw new Error(
      'useSyncedRequestContext must be used within an AppointmentProvider'
    );
  }

  return state;
};

export { SyncedRequestContext, useSyncedRequestContext };
